var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDarkLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29492 15.5918L13.4824 9.4043L13.8691 9L13.4824 8.5957L7.29492 2.4082L6.48633 3.2168L12.2695 9L6.48633 14.7832L7.29492 15.5918Z",
    fill: "#3b7af6",
    transform: "rotate(90 9 9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDarkLang);
export default __webpack_public_path__ + "static/media/arrowDarkLang.b003472466f9a7401302e1c18f21ad84.svg";
export { ForwardRef as ReactComponent };